export const ALL_COMPANIES_PANEL_TEST_IDS = {
  root: 'all-companies-panel',
  searchInput: 'all-companies-panel-search-input',
  fundFilterButton: 'all-companies-panel-fund-filter-button',
  fundFilterMenu: 'all-companies-panel-fund-filter-menu',
  fundFilterSearchInput: 'all-companies-panel-fund-filter-search-input',
  fundFilterOption: (fundId: null | number | string) => `all-companies-panel-fund-filter-option-${fundId ?? 'all'}`,
  list: 'all-companies-panel-list',
  skeleton: 'all-companies-panel-skeleton',
  emptyState: 'all-companies-panel-empty-state',
  errorState: 'all-companies-panel-error-state',
  companyItem: (companyId: number) => `all-companies-panel-company-${companyId}`,
  companyFundOverflow: (companyId: number) => `all-companies-panel-company-${companyId}-fund-overflow`,
} as const;
